"use strict"; /// <reference lib="DOM" />

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Creates a Blob to download the theme.
 * @param theme The theme to download.
 * @param name The theme's name.
 * @param colorSignature Either `hex` or `int`.
 * @returns The created blob the theme can be downloaded through.
 */

var toBlob = function toBlob(theme, name, colorSignature) {
  var serialized = theme.toString(colorSignature);
  var length = serialized.length;
  var buffer = new Uint8Array(length);

  for (var i = 0; i < length; i++) {
    buffer[i] = serialized.codePointAt(i);
  }

  var blob = URL.createObjectURL(new File([buffer], name));
  return blob;
};

exports["default"] = toBlob;